import { useEffect, useState } from 'react';
import { useAuthStore } from '@/lib/auth-store';
import { getTgWebApp, isInTelegram } from '@/lib/telegram';
import { telegramApi } from '@/api/telegram';

export function useTelegramAutoLogin() {
  const [done, setDone] = useState(!isInTelegram());
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const access = useAuthStore(s => s.accessToken);
  const setAccessToken = useAuthStore(s => s.setAccessToken);
  const consentGranted = localStorage.getItem('aniphys:tg-legal:2026-07-29') === '1';
  const aiConsent = localStorage.getItem('aniphys:tg-ai-consent:2026-07-29') === '1';

  useEffect(() => {
    const tg = getTgWebApp();
    if (!tg) { setDone(true); return; }
    if (!consentGranted) { setDone(false); return; }
    tg.ready();
    tg.expand();
    if (access) { setDone(true); return; }
    let cancelled = false;
    (async () => {
      try {
        setError(false);
        const res = await telegramApi.webappAuth({
          initData: tg.initData,
          accept_terms: true,
          accept_personal_data: true,
          accept_ai_data: aiConsent,
        });
        if (cancelled) return;
        setAccessToken(res.access_token);
      } catch (e) {
        console.warn('TG webapp auth failed', e);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setDone(true);
      }
    })();
    return () => { cancelled = true; };
  }, [access, aiConsent, attempt, consentGranted, setAccessToken]);

  return {
    done,
    error,
    consentGranted,
    retry: () => {
      setDone(false);
      setAttempt((value) => value + 1);
    },
  };
}
